import { IconButton } from '@fountain/fountain-ui-components';
import { Grid, Typography } from '@material-ui/core';
import { Icon, LinkOutlineIcon, TrashOutlineIcon } from '@fountain/ripple/icon';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import CustomDropzone from 'components/CustomDropzone';
import { EditButton } from 'containers/DataValidationModal/components/FileField/EditButton';
import { FileFieldTitle } from 'containers/DataValidationModal/components/FileField/FileFieldTitle';
import useStyles from 'containers/DataValidationModal/components/FileField/styles';
import { SharedPreviewProps } from 'containers/DataValidationModal/components/FileField/types';
import { iconLabels } from 'shared/iconLabels';
import { cssVar } from 'theme';

export type MobilePreviewProps = SharedPreviewProps;

export const MobilePreview: FC<MobilePreviewProps> = ({
  detail,
  error,
  file,
  handleUpload,
  isRequired,
  applicantBlob,
  isMobile,
  setIsEditable,
  showButtons,
  url,
}) => {
  const styles = useStyles();
  const intl = useIntl();
  const editButtonProps = {
    applicantBlob,
    isMobile,
    setIsEditable,
    showButtons,
    url,
  };
  return (
    <>
      <FileFieldTitle
        isRequired={isRequired}
        subtitle={detail.subtitle}
        title={detail.title}
      >
        <EditButton {...editButtonProps} />
      </FileFieldTitle>
      <CustomDropzone
        isMobile={isMobile}
        error={error}
        onChangeStatus={handleUpload}
      />
      <Grid
        className={styles.mobileUploadedFileContainer}
        container
        direction="row"
      >
        <IconButton aria-label={intl.formatMessage(iconLabels.attachedFile)}>
          <Icon
            icon={LinkOutlineIcon}
            size="sm"
            color="inherit"
            style={{ color: cssVar('neutral-900', 'currentColor') }}
          />
        </IconButton>
        <Typography className={styles.mobileUploadedFile}>
          {file ? file.name : applicantBlob[0].filename}
        </Typography>
        <IconButton
          type="button"
          aria-label={intl.formatMessage(iconLabels.remove)}
          onClick={() => setIsEditable(true)}
        >
          <Icon icon={TrashOutlineIcon} size="sm" color="neutral-400" />
        </IconButton>
      </Grid>
    </>
  );
};
